import { Field, Image, ImageField, Link, LinkField, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './CallToActionCarousel.module.css';

type CallToActionCarouselProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		items: [
			{
				name: string;
				displayName: string;
				fields: {
					Label: Field<string>;
					Statistic: Field<string>;
					Heading: Field<string>;
					Information: Field<string>;
					Link: LinkField;
					Subheading: Field<string>;
					Image: ImageField;
					CarouselPosition: { name?: string };
				};
			}
		];
	};
};

export default function CallToActionCarousel(props: CallToActionCarouselProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<section className={`${styles.carouselContainer} maxWidth padX padYL`}>
			<Text tag="h2" field={props.fields?.Title} className={styles.carouselHeader} />

			<div className={styles.carouselWrapper}>
				{props.fields?.items?.map((item, index) => {
					return (
						<div className={styles.carousel} key={index}>
							<div className={styles[item.fields?.CarouselPosition?.name?.toLowerCase() || '']}>
								<div className={`${item.fields?.Label?.value ? styles.hasLabel : styles.hasNoLabel}`}>
									<Text tag="h1" field={item.fields?.Heading} className={styles.cardHeading} />

									<div className={styles.registeredUsersContainer}>
										<Text tag="span" field={item.fields?.Statistic} className={styles.registeredUsers} />
										<Text tag="span" field={item.fields?.Information} className={styles.benefitsInformation} />
									</div>

									{item.fields?.Image?.value && <Image field={item.fields?.Image} className={styles.image} />}

									<RichText field={item.fields?.Subheading} className={styles.benefitsComparison} />

									<Link field={item.fields?.Link} className={styles.cardButton} />
								</div>
								{item.fields?.Label.value && <Text tag="span" field={item.fields?.Label} className={styles.memberExtraInformation} />}
							</div>
						</div>
					);
				})}
			</div>
		</section>
	);
}
